import {
  Document,
  Page,
  Text,
  StyleSheet,
  Image,
  View
} from '@react-pdf/renderer';
import { Chart, ChartMode } from './statistics';
import { formatDate } from './utils/utils';
import { options } from '../components/chartSelector';

const styles = StyleSheet.create({
  page: {
    padding: 30
  },
  section: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 30
  },
  chartSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20,
    marginTop: 20
  },
  strong: {
    fontSize: 20,
    fontWeight: '700'
  },
  content: {
    fontSize: 12
  },
  image: {
    width: 250, // Set the width of the image
    height: 'auto', // Set the height of the image
    minWidth: 250,
    marginBottom: 20
  }
});

interface StatisticsPdfProps {
  values: Chart[];
  base64Charts: string[];
}

export const StatisticsPDF = ({ values, base64Charts }: StatisticsPdfProps) => {

  function formatDateRange(value: Chart) {
    if (value.dateStart && value.dateEnd) {
      return formatDate(value.dateStart) + ' - ' + formatDate(value.dateEnd);
    }
    return '';
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          {base64Charts.map((base64: any, index) => {
            if (values[index].mode != ChartMode.chart) return <></>;
            if (values[index].type == '2') {
              return (
                <View style={styles.chartSection}>
                  <Text style={styles.content}>
                    {formatDateRange(values[index])}
                  </Text>
                  <Text style={styles.content}>
                    Selección:{' '}
                    {
                      options.find((option) => values[index].type === option.id)
                        ?.name
                    }
                  </Text>
                  <Text style={styles.content}>En el periodo seleccionado se atendieron:</Text>
                  <Text style={styles.strong}>{values[index].chartData[0].total}</Text>
                  <Text style={styles.content}>Citas</Text>
                </View>
              );
            }
            if(base64 && base64?.imgURI) {
                return (
                  <View style={styles.chartSection}>
                    <Text style={styles.content}>
                      {formatDateRange(values[index])}
                    </Text>
                    <Text style={styles.content}>
                      Selección:{' '}
                      {
                        options.find((option) => values[index].type === option.id)
                          ?.name
                      }
                    </Text>
                    <Image src={{ uri: base64.imgURI ?? '' }} style={styles.image} />
                  </View>
                );
            } else {
                return <></>;
            }
          })}
        </View>
      </Page>
    </Document>
  );
};
